var React = require('react');

function ArrowCircled (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"stroke":"#787878","d":"M17.6 11.14c0 4.722-3.828 8.55-8.55 8.55-4.722 0-8.55-3.828-8.55-8.55 0-4.722 3.828-8.55 8.55-8.55","key":0}),React.createElement("path",{"fill":"#787878","fillRule":"nonzero","d":"M9.12 0v5.49l4.75-2.75","key":1})]));
}

ArrowCircled.defaultProps = {"viewBox":"0 0 19 21"};

module.exports = ArrowCircled;

ArrowCircled.default = ArrowCircled;
